export const CONNECT_POPUP_NAME = "studio-social-connect";
export const CONNECT_RETURN_CHANNEL = "studio-social-connect-return";

export function announceSocialConnectReturn() {
  if (window.name !== CONNECT_POPUP_NAME || typeof BroadcastChannel === "undefined") {
    return;
  }
  const channel = new BroadcastChannel(CONNECT_RETURN_CHANNEL);
  channel.postMessage({ href: window.location.href });
  channel.close();
}
